import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from "redux-saga";
import tasksReducer from './features/tasks/tasksSlice';
import rootSaga from './rootSaga';

const sagaMiddleware = createSagaMiddleware();

const store  = configureStore({
    reducer: {
        tasks: tasksReducer,
    },
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
